(function () {
  var section = document.querySelector('.ty-section');
  var wrapper = document.getElementById('thankYouContent');

  var t = {
    noOrderTitle: section.getAttribute('data-t-no-order-title'),
    noOrderText: section.getAttribute('data-t-no-order-text'),
    continueShopping: section.getAttribute('data-t-continue-shopping'),
    order: section.getAttribute('data-t-order'),
    title: section.getAttribute('data-t-title'),
    subtitle: section.getAttribute('data-t-subtitle'),
    orderSummary: section.getAttribute('data-t-order-summary'),
    free: section.getAttribute('data-t-free'),
    discount: section.getAttribute('data-t-discount'),
    shipping: section.getAttribute('data-t-shipping'),
    freeShipping: section.getAttribute('data-t-free-shipping'),
    subtotal: section.getAttribute('data-t-subtotal'),
    total: section.getAttribute('data-t-total'),
    orderDetails: section.getAttribute('data-t-order-details'),
    email: section.getAttribute('data-t-email'),
    phone: section.getAttribute('data-t-phone'),
    paymentMethod: section.getAttribute('data-t-payment-method'),
    deliveryAddress: section.getAttribute('data-t-delivery-address'),
    paymentCod: section.getAttribute('data-t-payment-cod'),
    paymentCard: section.getAttribute('data-t-payment-card'),
    browseCollection: section.getAttribute('data-t-browse-collection')
  };

  function fmt(val) {
    var n = parseFloat(val);
    return isNaN(n) ? '0.00' : n.toFixed(2);
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  function renderNoOrder() {
    wrapper.innerHTML =
      '<div class="ty-empty">' +
        '<div class="ty-empty-icon">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>' +
        '</div>' +
        '<h2>' + esc(t.noOrderTitle) + '</h2>' +
        '<p>' + esc(t.noOrderText) + '</p>' +
        '<a href="/" class="ty-btn ty-btn-primary">' + esc(t.continueShopping) + '</a>' +
      '</div>';
  }

  function paymentMethodLabel(paymentType) {
    if (paymentType === 'cash_on_delivery') return t.paymentCod;
    if (paymentType === 'card') return t.paymentCard;
    return '';
  }

  function renderProducts(payload) {
    if (!payload.items || !payload.items.length) return { html: '', subtotal: 0 };
    var html = '<div class="ty-products">';
    var subtotal = 0;
    payload.items.forEach(function (item) {
      var price = parseFloat(item.amount) || 0;
      var qty = item.quantity || 1;
      var lineTotal = price * qty;
      subtotal += lineTotal;
      var isFree = price === 0;
      html +=
        '<div class="ty-product-row">' +
          '<div class="ty-product-info">' +
            '<div class="ty-product-qty">' + qty + ' &times;</div>' +
            '<div class="ty-product-name">' + esc(item.title) + '</div>' +
          '</div>' +
          '<div class="ty-product-price">' + (isFree ? esc(t.free) : fmt(lineTotal) + ' ' + esc(payload.currency)) + '</div>' +
        '</div>';
    });
    html += '</div>';
    return { html: html, subtotal: subtotal };
  }

  function discountRows(payload) {
    if (payload.discounts_display) return payload.discounts_display;
    // Comenzi puse in sessionStorage inainte de separarea coduri/reduceri automate.
    return (payload.discount_codes || []).map(function (d) {
      return { name: d.code, amount: parseFloat(d.amount) || 0 };
    });
  }

  function renderDiscountRow(payload) {
    var rows = discountRows(payload);
    if (!rows.length) return '';
    var total = rows.reduce(function (s, d) { return s + (parseFloat(d.amount) || 0); }, 0);
    if (total <= 0) return '';
    var badge = rows[0].name ? ' <span class="ty-discount-badge">' + esc(rows[0].name) + '</span>' : '';
    return (
      '<div class="ty-summary-row ty-summary-discount">' +
        '<span>' + esc(t.discount) + badge + '</span>' +
        '<span>-' + fmt(total) + ' ' + esc(payload.currency) + '</span>' +
      '</div>'
    );
  }

  function renderShippingRow(payload) {
    var amount = parseFloat(payload.delivery) || 0;
    if (amount > 0) {
      var label = payload.shippingTitle ? ' <span class="ty-shipping-label">(' + esc(payload.shippingTitle) + ')</span>' : '';
      return (
        '<div class="ty-summary-row">' +
          '<span>' + esc(t.shipping) + label + '</span>' +
          '<span>' + fmt(amount) + ' ' + esc(payload.currency) + '</span>' +
        '</div>'
      );
    }
    return (
      '<div class="ty-summary-row">' +
        '<span>' + esc(t.shipping) + '</span>' +
        '<span class="ty-free-shipping">' + esc(t.freeShipping) + '</span>' +
      '</div>'
    );
  }

  function renderDetails(payload) {
    var addressLine = '';
    if (payload.address1) {
      var parts = [payload.address1];
      if (payload.city) parts.push(payload.city);
      if (payload.province && payload.province !== payload.city) parts.push(payload.province);
      if (payload.zip) parts.push(payload.zip);
      addressLine = parts.join(', ');
    }
    var paymentMethod = paymentMethodLabel(payload.paymentType);

    if (!payload.email && !payload.phone && !addressLine && !paymentMethod) return '';

    var html = '<div class="ty-details">';
    html += '<h3 class="ty-details-title">' + esc(t.orderDetails) + '</h3>';
    html += '<div class="ty-details-grid">';
    if (payload.email) {
      html +=
        '<div class="ty-detail-item">' +
          '<div class="ty-detail-label">' + esc(t.email) + '</div>' +
          '<div class="ty-detail-value">' + esc(payload.email) + '</div>' +
        '</div>';
    }
    if (payload.phone) {
      html +=
        '<div class="ty-detail-item">' +
          '<div class="ty-detail-label">' + esc(t.phone) + '</div>' +
          '<div class="ty-detail-value">' + esc(payload.phone) + '</div>' +
        '</div>';
    }
    if (paymentMethod) {
      html +=
        '<div class="ty-detail-item">' +
          '<div class="ty-detail-label">' + esc(t.paymentMethod) + '</div>' +
          '<div class="ty-detail-value">' + esc(paymentMethod) + '</div>' +
        '</div>';
    }
    if (addressLine) {
      html +=
        '<div class="ty-detail-item ty-detail-full">' +
          '<div class="ty-detail-label">' + esc(t.deliveryAddress) + '</div>' +
          '<div class="ty-detail-value">' + esc(addressLine) + '</div>' +
        '</div>';
    }
    html += '</div></div>';
    return html;
  }

  function renderConfirmation(orderName, payload) {
    var headerHtml =
      '<div class="ty-header">' +
        '<div class="ty-check-wrap">' +
          '<svg class="ty-check-icon" viewBox="0 0 52 52"><circle class="ty-check-circle" cx="26" cy="26" r="25" fill="none"/><path class="ty-check-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>' +
        '</div>' +
        '<p class="ty-order-number">' + esc(t.order) + ' ' + esc(orderName) + '</p>' +
        '<h1 class="ty-title">' + esc(t.title) + '!</h1>' +
        '<p class="ty-subtitle">' + esc(t.subtitle) + '</p>' +
      '</div>';

    var bodyHtml = '';
    if (payload) {
      var products = renderProducts(payload);
      var total = parseFloat(payload.amount) || 0;

      bodyHtml =
        '<div class="ty-body">' +
          '<div class="ty-card ty-card-summary">' +
            '<h3 class="ty-card-title">' + esc(t.orderSummary) + '</h3>' +
            products.html +
            '<div class="ty-summary-totals">' +
              '<div class="ty-summary-row">' +
                '<span>' + esc(t.subtotal) + '</span>' +
                '<span>' + fmt(products.subtotal) + ' ' + esc(payload.currency) + '</span>' +
              '</div>' +
              renderDiscountRow(payload) +
              renderShippingRow(payload) +
              '<div class="ty-summary-row ty-summary-total">' +
                '<span>' + esc(t.total) + '</span>' +
                '<span>' + fmt(total) + ' ' + esc(payload.currency) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
          renderDetails(payload) +
        '</div>';
    }

    var footerHtml =
      '<div class="ty-footer">' +
        '<a href="/" class="ty-btn ty-btn-primary">' + esc(t.continueShopping) + '</a>' +
        '<a href="/collections/all" class="ty-btn ty-btn-secondary">' + esc(t.browseCollection) + '</a>' +
      '</div>';

    wrapper.innerHTML = headerHtml + bodyHtml + footerHtml;
  }

  var params = new URLSearchParams(window.location.search);
  var orderName = params.get('order') || '';
  var shopifyOrderId = params.get('id') || '';

  var stored = null;
  try {
    var raw = sessionStorage.getItem('lastOrder');
    if (raw) stored = JSON.parse(raw);
  } catch (e) {}

  if (!orderName && !shopifyOrderId) {
    renderNoOrder();
    return;
  }

  renderConfirmation(orderName, stored && stored.payload);

  var numericId = (shopifyOrderId.match(/\d+/) || [''])[0];
  var guardKey = numericId || orderName;
  var alreadyProcessed = false;
  try {
    alreadyProcessed = !!(guardKey && sessionStorage.getItem('purchased_' + guardKey));
  } catch (e) {}

  if (!alreadyProcessed) {
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } }).catch(function () {});
    if (typeof window.clearDiscount === 'function') {
      try { window.clearDiscount(); } catch (e) {}
    }

    if (window.SalutAttribution && numericId) window.SalutAttribution.report({ orderId: numericId });

    try { if (guardKey) sessionStorage.setItem('purchased_' + guardKey, '1'); } catch (e) {}
    try { sessionStorage.removeItem('lastOrder'); } catch (e) {}
  }
})();
